/**
 * Created by mateimisarca on 20.03.2021
 */

import AdminContainer from './admin-container';

export default AdminContainer;
